import { render, staticRenderFns } from "./msg_banner.vue?vue&type=template&id=1d1c9d1f&"
import script from "./msg_banner.vue?vue&type=script&lang=js&"
export * from "./msg_banner.vue?vue&type=script&lang=js&"
import style0 from "./msg_banner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports